export enum ExportType {
    PAYMENTS = 'Payments',
    ATTENDANCE = 'Attendance',
    EVENT_PAYMENTS = 'EventPayments',
    STUDENT_PROGRESS = 'LiveSubscriptionProgress'
}